import { Form, Validators, field } from "fw-model";

const { required, isMinLength } = Validators;

export class ResetUserPasswordAction {
    constructor(
        public form: ResetPasswordForm,
        public resetToken: string
    ) {}
}

export class ResetPasswordForm extends Form {
    @field("Password", required, isMinLength(12))
    public Password: string = null;
}
